export * from "./src/index.ts";
export * from "./src/managers/InteractionManager.ts";
export * from "./src/utils/urlBuilder.ts";
export * from "./src/types.ts";

const PIPER_VOICES_BASE = "/aic-runtime-deps/voices/piper/";

export const voices = {
  kareem: {
    name: "kareem",
    modelUrl: `${PIPER_VOICES_BASE}ar/ar_JO/kareem/medium/ar_JO-kareem-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}ar/ar_JO/kareem/medium/ar_JO-kareem-medium.onnx.json`,
    speakerId: undefined,
    gender: "m",
    language: "ar-JO",
    languageName: "Arabic (Jordan)",
  },
  maria: {
    name: "maria",
    modelUrl: `${PIPER_VOICES_BASE}ca/ca_ES/upc_ona/medium/ca_ES-upc_ona-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}ca/ca_ES/upc_ona/medium/ca_ES-upc_ona-medium.onnx.json`,
    speakerId: undefined,
    gender: "f",
    language: "ca-ES",
    languageName: "Catalan (Spain)",
  },
  huayan: {
    name: "huayan",
    modelUrl: `${PIPER_VOICES_BASE}zh/zh_CN/huayan/medium/zh_CN-huayan-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}zh/zh_CN/huayan/medium/zh_CN-huayan-medium.onnx.json`,
    speakerId: undefined,
    gender: "f",
    language: "zh-CN",
    languageName: "Chinese (China)",
  },
  jirka: {
    name: "jirka",
    modelUrl: `${PIPER_VOICES_BASE}cs/cs_CZ/jirka/medium/cs_CZ-jirka-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}cs/cs_CZ/jirka/medium/cs_CZ-jirka-medium.onnx.json`,
    speakerId: undefined,
    gender: "m",
    language: "cs-CZ",
    languageName: "Czech (Czech Republic)",
  },
  lars: {
    name: "lars",
    modelUrl: `${PIPER_VOICES_BASE}da/da_DK/talesyntese/medium/da_DK-talesyntese-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}da/da_DK/talesyntese/medium/da_DK-talesyntese-medium.onnx.json`,
    speakerId: undefined,
    gender: "m",
    language: "da-DK",
    languageName: "Danish (Denmark)",
  },
  nathalie: {
    name: "nathalie",
    modelUrl: `${PIPER_VOICES_BASE}nl/nl_BE/nathalie/medium/nl_BE-nathalie-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}nl/nl_BE/nathalie/medium/nl_BE-nathalie-medium.onnx.json`,
    speakerId: undefined,
    gender: "f",
    language: "nl-BE",
    languageName: "Dutch (Belgium)",
  },
  louis: {
    name: "louis",
    modelUrl: `${PIPER_VOICES_BASE}nl/nl_BE/rdh/medium/nl_BE-rdh-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}nl/nl_BE/rdh/medium/nl_BE-rdh-medium.onnx.json`,
    speakerId: undefined,
    gender: "m",
    language: "nl-BE",
    languageName: "Dutch (Belgium)",
  },
  pim: {
    name: "pim",
    modelUrl: `${PIPER_VOICES_BASE}nl/nl_NL/pim/medium/nl_NL-pim-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}nl/nl_NL/pim/medium/nl_NL-pim-medium.onnx.json`,
    speakerId: undefined,
    gender: "m",
    language: "nl-NL",
    languageName: "Dutch (Netherlands)",
  },
  ronnie: {
    name: "ronnie",
    modelUrl: `${PIPER_VOICES_BASE}nl/nl_NL/ronnie/medium/nl_NL-ronnie-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}nl/nl_NL/ronnie/medium/nl_NL-ronnie-medium.onnx.json`,
    speakerId: undefined,
    gender: "m",
    language: "nl-NL",
    languageName: "Dutch (Netherlands)",
  },
  "wataame-chibi": {
    name: "wataame-chibi",
    modelUrl: `${PIPER_VOICES_BASE}en/en_US/libritts_r/medium/en_US-libritts_r-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}en/en_US/libritts_r/medium/en_US-libritts_r-medium.onnx.json`,
    speakerId: 595,
    gender: "f",
    language: "en-US",
    languageName: "English (United States)",
  },
  "wataame-v1": {
    name: "wataame-v1",
    modelUrl: `${PIPER_VOICES_BASE}en/en_US/libritts_r/medium/en_US-libritts_r-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}en/en_US/libritts_r/medium/en_US-libritts_r-medium.onnx.json`,
    speakerId: 11,
    gender: "f",
    language: "en-US",
    languageName: "English (United States)",
  },
  "wataame-v2": {
    name: "wataame-v2",
    modelUrl: `${PIPER_VOICES_BASE}en/en_US/libritts_r/medium/en_US-libritts_r-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}en/en_US/libritts_r/medium/en_US-libritts_r-medium.onnx.json`,
    speakerId: 869,
    gender: "f",
    language: "en-US",
    languageName: "English (United States)",
  },
  ruri: {
    name: "ruri",
    modelUrl: `${PIPER_VOICES_BASE}en/en_US/libritts_r/medium/en_US-libritts_r-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}en/en_US/libritts_r/medium/en_US-libritts_r-medium.onnx.json`,
    speakerId: 250,
    gender: "f",
    language: "en-US",
    languageName: "English (United States)",
  },
  yui: {
    name: "yui",
    modelUrl: `${PIPER_VOICES_BASE}en/en_US/libritts_r/medium/en_US-libritts_r-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}en/en_US/libritts_r/medium/en_US-libritts_r-medium.onnx.json`,
    speakerId: 307,
    gender: "f",
    language: "en-US",
    languageName: "English (United States)",
  },
  teco: {
    name: "yui",
    modelUrl: `${PIPER_VOICES_BASE}en/en_US/libritts_r/medium/en_US-libritts_r-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}en/en_US/libritts_r/medium/en_US-libritts_r-medium.onnx.json`,
    speakerId: 131,
    gender: "f",
    language: "en-US",
    languageName: "English (United States)",
  },
  olivia: {
    name: "olivia",
    modelUrl: `${PIPER_VOICES_BASE}en/en_US/libritts_r/medium/en_US-libritts_r-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}en/en_US/libritts_r/medium/en_US-libritts_r-medium.onnx.json`,
    speakerId: 894,
    gender: "f",
    language: "en-US",
    languageName: "English (United States)",
  },
  lindsey: {
    name: "lindsey",
    modelUrl: `${PIPER_VOICES_BASE}en/en_US/libritts_r/medium/en_US-libritts_r-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}en/en_US/libritts_r/medium/en_US-libritts_r-medium.onnx.json`,
    speakerId: 4,
    gender: "f",
    language: "en-US",
    languageName: "English (United States)",
  },
  emma: {
    name: "emma",
    modelUrl: `${PIPER_VOICES_BASE}en/en_US/hfc_female/medium/en_US-hfc_female-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}en/en_US/hfc_female/medium/en_US-hfc_female-medium.onnx.json`,
    speakerId: undefined,
    gender: "f",
    language: "en-US",
    languageName: "English (United States)",
  },
  kristin: {
    name: "kristin",
    modelUrl: `${PIPER_VOICES_BASE}en/en_US/kristin/medium/en_US-kristin-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}en/en_US/kristin/medium/en_US-kristin-medium.onnx.json`,
    speakerId: undefined,
    gender: "f",
    language: "en-US",
    languageName: "English (United States)",
  },
  norman: {
    name: "norman",
    modelUrl: `${PIPER_VOICES_BASE}en/en_US/norman/medium/en_US-norman-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}en/en_US/norman/medium/en_US-norman-medium.onnx.json`,
    speakerId: undefined,
    gender: "m",
    language: "en-US",
    languageName: "English (United States)",
  },
  johnny: {
    name: "johnny",
    modelUrl: `${PIPER_VOICES_BASE}en/en_US/libritts_r/medium/en_US-libritts_r-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}en/en_US/libritts_r/medium/en_US-libritts_r-medium.onnx.json`,
    speakerId: 8,
    gender: "m",
    language: "en-US",
    languageName: "English (United States)",
  },
  homer: {
    name: "homer",
    modelUrl: `${PIPER_VOICES_BASE}en/en_US/libritts_r/medium/en_US-libritts_r-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}en/en_US/libritts_r/medium/en_US-libritts_r-medium.onnx.json`,
    speakerId: 2,
    gender: "m",
    language: "en-US",
    languageName: "English (United States)",
  },
  gary: {
    name: "gary",
    modelUrl: `${PIPER_VOICES_BASE}en/en_US/libritts_r/medium/en_US-libritts_r-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}en/en_US/libritts_r/medium/en_US-libritts_r-medium.onnx.json`,
    speakerId: 3,
    gender: "m",
    language: "en-US",
    languageName: "English (United States)",
  },
  manny: {
    name: "manny",
    modelUrl: `${PIPER_VOICES_BASE}en/en_US/libritts_r/medium/en_US-libritts_r-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}en/en_US/libritts_r/medium/en_US-libritts_r-medium.onnx.json`,
    speakerId: 902,
    gender: "m",
    language: "en-US",
    languageName: "English (United States)",
  },
  noah: {
    name: "noah",
    modelUrl: `${PIPER_VOICES_BASE}en/en_US/libritts_r/medium/en_US-libritts_r-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}en/en_US/libritts_r/medium/en_US-libritts_r-medium.onnx.json`,
    speakerId: 901,
    gender: "m",
    language: "en-US",
    languageName: "English (United States)",
  },
  liam: {
    name: "liam",
    modelUrl: `${PIPER_VOICES_BASE}en/en_US/libritts_r/medium/en_US-libritts_r-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}en/en_US/libritts_r/medium/en_US-libritts_r-medium.onnx.json`,
    speakerId: 900,
    gender: "m",
    language: "en-US",
    languageName: "English (United States)",
  },
  william: {
    name: "william",
    modelUrl: `${PIPER_VOICES_BASE}en/en_US/libritts_r/medium/en_US-libritts_r-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}en/en_US/libritts_r/medium/en_US-libritts_r-medium.onnx.json`,
    speakerId: 898,
    gender: "m",
    language: "en-US",
    languageName: "English (United States)",
  },
  ben: {
    name: "ben",
    modelUrl: `${PIPER_VOICES_BASE}en/en_US/libritts_r/medium/en_US-libritts_r-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}en/en_US/libritts_r/medium/en_US-libritts_r-medium.onnx.json`,
    speakerId: 896,
    gender: "m",
    language: "en-US",
    languageName: "English (United States)",
  },
  mason: {
    name: "mason",
    modelUrl: `${PIPER_VOICES_BASE}en/en_US/libritts_r/medium/en_US-libritts_r-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}en/en_US/libritts_r/medium/en_US-libritts_r-medium.onnx.json`,
    speakerId: 895,
    gender: "m",
    language: "en-US",
    languageName: "English (United States)",
  },
  bryce: {
    name: "bryce",
    modelUrl: `${PIPER_VOICES_BASE}en/en_US/bryce/medium/en_US-bryce-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}en/en_US/bryce/medium/en_US-bryce-medium.onnx.json`,
    speakerId: undefined,
    gender: "m",
    language: "en-US",
    languageName: "English (United States)",
  },
  ryan: {
    name: "ryan",
    modelUrl: `${PIPER_VOICES_BASE}en/en_US/ryan/medium/en_US-ryan-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}en/en_US/ryan/medium/en_US-ryan-medium.onnx.json`,
    speakerId: undefined,
    gender: "m",
    language: "en-US",
    languageName: "English (United States)",
  },
  alba: {
    name: "alba",
    modelUrl: `${PIPER_VOICES_BASE}en/en_GB/alba/medium/en_GB-alba-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}en/en_GB/alba/medium/en_GB-alba-medium.onnx.json`,
    speakerId: undefined,
    gender: "f",
    language: "en-GB",
    languageName: "English (Great Britain)",
  },
  jenny: {
    name: "jenny",
    modelUrl: `${PIPER_VOICES_BASE}en/en_GB/aru/medium/en_GB-aru-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}en/en_GB/aru/medium/en_GB-aru-medium.onnx.json`,
    speakerId: 0,
    gender: "f",
    language: "en-GB",
    languageName: "English (Great Britain)",
  },

  meggan: {
    name: "meggan",
    modelUrl: `${PIPER_VOICES_BASE}en/en_GB/aru/medium/en_GB-aru-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}en/en_GB/aru/medium/en_GB-aru-medium.onnx.json`,
    speakerId: 4,
    gender: "f",
    language: "en-GB",
    languageName: "English (Great Britain)",
  },
  emily: {
    name: "emily",
    modelUrl: `${PIPER_VOICES_BASE}en/en_GB/aru/medium/en_GB-aru-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}en/en_GB/aru/medium/en_GB-aru-medium.onnx.json`,
    speakerId: 5,
    gender: "f",
    language: "en-GB",
    languageName: "English (Great Britain)",
  },
  gertrude: {
    name: "gertrude",
    modelUrl: `${PIPER_VOICES_BASE}en/en_GB/aru/medium/en_GB-aru-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}en/en_GB/aru/medium/en_GB-aru-medium.onnx.json`,
    speakerId: 6,
    gender: "f",
    language: "en-GB",
    languageName: "English (Great Britain)",
  },
  bridget: {
    name: "bridget",
    modelUrl: `${PIPER_VOICES_BASE}en/en_GB/aru/medium/en_GB-aru-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}en/en_GB/aru/medium/en_GB-aru-medium.onnx.json`,
    speakerId: 10,
    gender: "f",
    language: "en-GB",
    languageName: "English (Great Britain)",
  },
  molly: {
    name: "molly",
    modelUrl: `${PIPER_VOICES_BASE}en/en_GB/aru/medium/en_GB-aru-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}en/en_GB/aru/medium/en_GB-aru-medium.onnx.json`,
    speakerId: 11,
    gender: "f",
    language: "en-GB",
    languageName: "English (Great Britain)",
  },

  alan: {
    name: "alan",
    modelUrl: `${PIPER_VOICES_BASE}en/en_GB/alan/medium/en_GB-alan-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}en/en_GB/alan/medium/en_GB-alan-medium.onnx.json`,
    speakerId: undefined,
    gender: "m",
    language: "en-GB",
    languageName: "English (Great Britain)",
  },
  greg: {
    name: "greg",
    modelUrl: `${PIPER_VOICES_BASE}en/en_GB/aru/medium/en_GB-aru-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}en/en_GB/aru/medium/en_GB-aru-medium.onnx.json`,
    speakerId: 1,
    gender: "m",
    language: "en-GB",
    languageName: "English (Great Britain)",
  },
  bob: {
    name: "bob",
    modelUrl: `${PIPER_VOICES_BASE}en/en_GB/aru/medium/en_GB-aru-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}en/en_GB/aru/medium/en_GB-aru-medium.onnx.json`,
    speakerId: 2,
    gender: "m",
    language: "en-GB",
    languageName: "English (Great Britain)",
  },
  james: {
    name: "james",
    modelUrl: `${PIPER_VOICES_BASE}en/en_GB/aru/medium/en_GB-aru-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}en/en_GB/aru/medium/en_GB-aru-medium.onnx.json`,
    speakerId: 3,
    gender: "m",
    language: "en-GB",
    languageName: "English (Great Britain)",
  },
  john: {
    name: "john",
    modelUrl: `${PIPER_VOICES_BASE}en/en_GB/aru/medium/en_GB-aru-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}en/en_GB/aru/medium/en_GB-aru-medium.onnx.json`,
    speakerId: 8,
    gender: "m",
    language: "en-GB",
    languageName: "English (Great Britain)",
  },
  gray: {
    name: "gray",
    modelUrl: `${PIPER_VOICES_BASE}en/en_GB/aru/medium/en_GB-aru-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}en/en_GB/aru/medium/en_GB-aru-medium.onnx.json`,
    speakerId: 9,
    gender: "m",
    language: "en-GB",
    languageName: "English (Great Britain)",
  },
  ahmad: {
    name: "ahmad",
    modelUrl: `${PIPER_VOICES_BASE}fa/fa_IR/gyro/medium/fa_IR-gyro-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}fa/fa_IR/gyro/medium/fa_IR-gyro-medium.onnx.json`,
    speakerId: undefined,
    gender: "m",
    language: "fa-IR",
    languageName: "Farsi (Iran)",
  },
  ganji: {
    name: "ganji",
    modelUrl: `${PIPER_VOICES_BASE}fa/fa_IR/ganji/medium/fa_IR-ganji-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}fa/fa_IR/ganji/medium/fa_IR-ganji-medium.onnx.json`,
    speakerId: undefined,
    gender: "m",
    language: "fa-IR",
    languageName: "Farsi (Iran)",
  },
  amir: {
    name: "amir",
    modelUrl: `${PIPER_VOICES_BASE}fa/fa_IR/amir/medium/fa_IR-amir-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}fa/fa_IR/amir/medium/fa_IR-amir-medium.onnx.json`,
    speakerId: undefined,
    gender: "m",
    language: "fa-IR",
    languageName: "Farsi (Iran)",
  },
  harri: {
    name: "harri",
    modelUrl: `${PIPER_VOICES_BASE}fi/fi_FI/harri/medium/fi_FI-harri-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}fi/fi_FI/harri/medium/fi_FI-harri-medium.onnx.json`,
    speakerId: undefined,
    gender: "m",
    language: "fi-FI",
    languageName: "Finnish (Finland)",
  },
  chloe: {
    name: "chloe",
    modelUrl: `${PIPER_VOICES_BASE}fr/fr_FR/siwis/medium/fr_FR-siwis-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}fr/fr_FR/siwis/medium/fr_FR-siwis-medium.onnx.json`,
    speakerId: undefined,
    gender: "f",
    language: "fr-FR",
    languageName: "French (France)",
  },
  jessica: {
    name: "jessica",
    modelUrl: `${PIPER_VOICES_BASE}fr/fr_FR/upmc/medium/fr_FR-upmc-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}fr/fr_FR/upmc/medium/fr_FR-upmc-medium.onnx.json`,
    speakerId: 0,
    gender: "f",
    language: "fr-FR",
    languageName: "French (France)",
  },
  pierre: {
    name: "pierre",
    modelUrl: `${PIPER_VOICES_BASE}fr/fr_FR/upmc/medium/fr_FR-upmc-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}fr/fr_FR/upmc/medium/fr_FR-upmc-medium.onnx.json`,
    speakerId: 1,
    gender: "m",
    language: "fr-FR",
    languageName: "French (France)",
  },
  natia: {
    name: "natia",
    modelUrl: `${PIPER_VOICES_BASE}ka/ka_GE/natia/medium/ka_GE-natia-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}ka/ka_GE/natia/medium/ka_GE-natia-medium.onnx.json`,
    speakerId: undefined,
    gender: "f",
    language: "ka-GE",
    languageName: "Georgian (Georgia)",
  },
  thorsten: {
    name: "thorsten",
    modelUrl: `${PIPER_VOICES_BASE}de/de_DE/thorsten/medium/de_DE-thorsten-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}de/de_DE/thorsten/medium/de_DE-thorsten-medium.onnx.json`,
    speakerId: undefined,
    gender: "m",
    language: "de-DE",
    languageName: "German (Germany)",
  },
  daniela: {
    name: "daniela",
    modelUrl: `${PIPER_VOICES_BASE}es/es_AR/daniela/high/es_AR-daniela-high.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}es/es_AR/daniela/high/es_AR-daniela-high.onnx.json`,
    speakerId: undefined,
    gender: "f",
    language: "es-AR",
    languageName: "Spanish (Argentina)",
  },
  isabella: {
    name: "isabella",
    modelUrl: `${PIPER_VOICES_BASE}es/es_ES/sharvard/medium/es_ES-sharvard-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}es/es_ES/sharvard/medium/es_ES-sharvard-medium.onnx.json`,
    speakerId: 1,
    gender: "f",
    language: "es-ES",
    languageName: "Spanish (Spain)",
  },
  diego: {
    name: "diego",
    modelUrl: `${PIPER_VOICES_BASE}es/es_ES/sharvard/medium/es_ES-sharvard-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}es/es_ES/sharvard/medium/es_ES-sharvard-medium.onnx.json`,
    speakerId: 0,
    gender: "m",
    language: "es-ES",
    languageName: "Spanish (Spain)",
  },
  lucia: {
    name: "lucia",
    modelUrl: `${PIPER_VOICES_BASE}es/es_MX/claude/high/es_MX-claude-high.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}es/es_MX/claude/high/es_MX-claude-high.onnx.json`,
    speakerId: undefined,
    gender: "f",
    language: "es-MX",
    languageName: "Spanish (Mexico)",
  },
  miguel: {
    name: "miguel",
    modelUrl: `${PIPER_VOICES_BASE}es/es_MX/ald/medium/es_MX-ald-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}es/es_MX/ald/medium/es_MX-ald-medium.onnx.json`,
    speakerId: undefined,
    gender: "m",
    language: "es-MX",
    languageName: "Spanish (Mexico)",
  },
  vidya: {
    name: "vidya",
    modelUrl: `${PIPER_VOICES_BASE}hi/hi_IN/priyamvada/medium/hi_IN-priyamvada-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}hi/hi_IN/priyamvada/medium/hi_IN-priyamvada-medium.onnx.json`,
    speakerId: undefined,
    gender: "f",
    language: "hi-IN",
    languageName: "Hindi (India)",
  },
  rahul: {
    name: "rahul",
    modelUrl: `${PIPER_VOICES_BASE}hi/hi_IN/pratham/medium/hi_IN-pratham-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}hi/hi_IN/pratham/medium/hi_IN-pratham-medium.onnx.json`,
    speakerId: undefined,
    gender: "m",
    language: "hi-IN",
    languageName: "Hindi (India)",
  },
  berta: {
    name: "berta",
    modelUrl: `${PIPER_VOICES_BASE}hu/hu_HU/berta/medium/hu_HU-berta-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}hu/hu_HU/berta/medium/hu_HU-berta-medium.onnx.json`,
    speakerId: undefined,
    gender: "f",
    language: "hu-HU",
    languageName: "Hungarian (Hungary)",
  },
  ugla: {
    name: "ugla",
    modelUrl: `${PIPER_VOICES_BASE}is/is_IS/ugla/medium/is_IS-ugla-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}is/is_IS/ugla/medium/is_IS-ugla-medium.onnx.json`,
    speakerId: undefined,
    gender: "f",
    language: "is-IS",
    languageName: "Icelandic (Iceland)",
  },
  steinn: {
    name: "steinn",
    modelUrl: `${PIPER_VOICES_BASE}is/is_IS/steinn/medium/is_IS-steinn-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}is/is_IS/steinn/medium/is_IS-steinn-medium.onnx.json`,
    speakerId: undefined,
    gender: "m",
    language: "is-IS",
    languageName: "Icelandic (Iceland)",
  },
  salka: {
    name: "salka",
    modelUrl: `${PIPER_VOICES_BASE}is/is_IS/salka/medium/is_IS-salka-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}is/is_IS/salka/medium/is_IS-salka-medium.onnx.json`,
    speakerId: undefined,
    gender: "f",
    language: "is-IS",
    languageName: "Icelandic (Iceland)",
  },
  bui: {
    name: "bui",
    modelUrl: `${PIPER_VOICES_BASE}is/is_IS/bui/medium/is_IS-bui-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}is/is_IS/bui/medium/is_IS-bui-medium.onnx.json`,
    speakerId: undefined,
    gender: "m",
    language: "is-IS",
    languageName: "Icelandic (Iceland)",
  },
  paola: {
    name: "paola",
    modelUrl: `${PIPER_VOICES_BASE}it/it_IT/paola/medium/it_IT-paola-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}it/it_IT/paola/medium/it_IT-paola-medium.onnx.json`,
    speakerId: undefined,
    gender: "f",
    language: "it-IT",
    languageName: "Italian (Italy)",
  },

  aigerim: {
    name: "aigerim",
    modelUrl: `${PIPER_VOICES_BASE}kk/kk_KZ/issai/high/kk_KZ-issai-high.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}kk/kk_KZ/issai/high/kk_KZ-issai-high.onnx.json`,
    speakerId: 2,
    gender: "f",
    language: "kk-KZ",
    languageName: "Kazakh (Kazakhstan)",
  },
  raya: {
    name: "raya",
    modelUrl: `${PIPER_VOICES_BASE}kk/kk_KZ/issai/high/kk_KZ-issai-high.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}kk/kk_KZ/issai/high/kk_KZ-issai-high.onnx.json`,
    speakerId: 3,
    gender: "f",
    language: "kk-KZ",
    languageName: "Kazakh (Kazakhstan)",
  },
  alikhan: {
    name: "alikhan",
    modelUrl: `${PIPER_VOICES_BASE}kk/kk_KZ/issai/high/kk_KZ-issai-high.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}kk/kk_KZ/issai/high/kk_KZ-issai-high.onnx.json`,
    speakerId: 0,
    gender: "m",
    language: "kk-KZ",
    languageName: "Kazakh (Kazakhstan)",
  },
  nurlan: {
    name: "nurlan",
    modelUrl: `${PIPER_VOICES_BASE}kk/kk_KZ/issai/high/kk_KZ-issai-high.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}kk/kk_KZ/issai/high/kk_KZ-issai-high.onnx.json`,
    speakerId: 1,
    gender: "m",
    language: "kk-KZ",
    languageName: "Kazakh (Kazakhstan)",
  },
  janis: {
    name: "janis",
    modelUrl: `${PIPER_VOICES_BASE}lv/lv_LV/aivars/medium/lv_LV-aivars-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}lv/lv_LV/aivars/medium/lv_LV-aivars-medium.onnx.json`,
    speakerId: undefined,
    gender: "m",
    language: "lv-LV",
    languageName: "Latvian (Latvia)",
  },
  eva: {
    name: "eva",
    modelUrl: `${PIPER_VOICES_BASE}lb/lb_LU/marylux/medium/lb_LU-marylux-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}lb/lb_LU/marylux/medium/lb_LU-marylux-medium.onnx.json`,
    speakerId: undefined,
    gender: "f",
    language: "lb-LU",
    languageName: "Luxembourgish (Luxembourg)",
  },
  meera: {
    name: "meera",
    modelUrl: `${PIPER_VOICES_BASE}ml/ml_IN/meera/medium/ml_IN-meera-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}ml/ml_IN/meera/medium/ml_IN-meera-medium.onnx.json`,
    speakerId: undefined,
    gender: "f",
    language: "ml-IN",
    languageName: "Malayalam (India)",
  },
  arjun: {
    name: "arjun",
    modelUrl: `${PIPER_VOICES_BASE}ml/ml_IN/arjun/medium/ml_IN-arjun-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}ml/ml_IN/arjun/medium/ml_IN-arjun-medium.onnx.json`,
    speakerId: undefined,
    gender: "m",
    language: "ml-IN",
    languageName: "Malayalam (India)",
  },
  sita: {
    name: "sita",
    modelUrl: `${PIPER_VOICES_BASE}ne/ne_NP/google/medium/ne_NP-google-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}ne/ne_NP/google/medium/ne_NP-google-medium.onnx.json`,
    speakerId: 0,
    gender: "f",
    language: "ne-NP",
    languageName: "Nepali (Nepal)",
  },
  saraswati: {
    name: "saraswati",
    modelUrl: `${PIPER_VOICES_BASE}ne/ne_NP/google/medium/ne_NP-google-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}ne/ne_NP/google/medium/ne_NP-google-medium.onnx.json`,
    speakerId: 1,
    gender: "f",
    language: "ne-NP",
    languageName: "Nepali (Nepal)",
  },
  laxmi: {
    name: "laxmi",
    modelUrl: `${PIPER_VOICES_BASE}ne/ne_NP/google/medium/ne_NP-google-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}ne/ne_NP/google/medium/ne_NP-google-medium.onnx.json`,
    speakerId: 2,
    gender: "f",
    language: "ne-NP",
    languageName: "Nepali (Nepal)",
  },
  palmu: {
    name: "palmu",
    modelUrl: `${PIPER_VOICES_BASE}ne/ne_NP/google/medium/ne_NP-google-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}ne/ne_NP/google/medium/ne_NP-google-medium.onnx.json`,
    speakerId: 3,
    gender: "f",
    language: "ne-NP",
    languageName: "Nepali (Nepal)",
  },
  nisha: {
    name: "nisha",
    modelUrl: `${PIPER_VOICES_BASE}ne/ne_NP/google/medium/ne_NP-google-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}ne/ne_NP/google/medium/ne_NP-google-medium.onnx.json`,
    speakerId: 5,
    gender: "f",
    language: "ne-NP",
    languageName: "Nepali (Nepal)",
  },
  usha: {
    name: "usha",
    modelUrl: `${PIPER_VOICES_BASE}ne/ne_NP/google/medium/ne_NP-google-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}ne/ne_NP/google/medium/ne_NP-google-medium.onnx.json`,
    speakerId: 6,
    gender: "f",
    language: "ne-NP",
    languageName: "Nepali (Nepal)",
  },
  "saraswati-slow": {
    name: "saraswati-slow",
    modelUrl: `${PIPER_VOICES_BASE}ne/ne_NP/google/medium/ne_NP-google-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}ne/ne_NP/google/medium/ne_NP-google-medium.onnx.json`,
    speakerId: 12,
    gender: "f",
    language: "ne-NP",
    languageName: "Nepali (Nepal)",
  },
  chitwan: {
    name: "chitwan",
    modelUrl: `${PIPER_VOICES_BASE}ne/ne_NP/chitwan/medium/ne_NP-chitwan-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}ne/ne_NP/chitwan/medium/ne_NP-chitwan-medium.onnx.json`,
    speakerId: undefined,
    gender: "m",
    language: "ne-NP",
    languageName: "Nepali (Nepal)",
  },
  aksel: {
    name: "aksel",
    modelUrl: `${PIPER_VOICES_BASE}no/no_NO/talesyntese/medium/no_NO-talesyntese-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}nl/nl_NL/talesyntese/medium/no_NO-talesyntese-medium.onnx.json`,
    speakerId: undefined,
    gender: "m",
    language: "no-NO",
    languageName: "Norwegian (Norway)",
  },
  gosia: {
    name: "gosia",
    modelUrl: `${PIPER_VOICES_BASE}pl/pl_PL/gosia/medium/pl_PL-gosia-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}pl/pl_PL/gosia/medium/pl_PL-gosia-medium.onnx.json`,
    speakerId: undefined,
    gender: "f",
    language: "pl-PL",
    languageName: "Polish (Poland)",
  },
  antoni: {
    name: "antoni",
    modelUrl: `${PIPER_VOICES_BASE}pl/pl_PL/mc_speech/medium/pl_PL-mc_speech-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}pl/pl_PL/mc_speech/medium/pl_PL-mc_speech-medium.onnx.json`,
    speakerId: undefined,
    gender: "m",
    language: "pl-PL",
    languageName: "Polish (Poland)",
  },
  cadu: {
    name: "cadu",
    modelUrl: `${PIPER_VOICES_BASE}pt/pt_BR/cadu/medium/pt_BR-cadu-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}pt/pt_BR/cadu/medium/pt_BR-cadu-medium.onnx.json`,
    speakerId: undefined,
    gender: "m",
    language: "pt-BR",
    languageName: "Portuguese (Brazil)",
  },
  afonso: {
    name: "afonso",
    modelUrl: `${PIPER_VOICES_BASE}pt/pt_PT/tugao/medium/pt_PT-tugao-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}pt/pt_PT/tugao/medium/pt_PT-tugao-medium.onnx.json`,
    speakerId: undefined,
    gender: "m",
    language: "pt-PT",
    languageName: "Portuguese (Portugal)",
  },
  mihai: {
    name: "mihai",
    modelUrl: `${PIPER_VOICES_BASE}ro/ro_RO/mihai/medium/ro_RO-mihai-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}ro/ro_RO/mihai/medium/ro_RO-mihai-medium.onnx.json`,
    speakerId: undefined,
    gender: "m",
    language: "ro-RO",
    languageName: "Romanian (Romania)",
  },
  irina: {
    name: "irina",
    modelUrl: `${PIPER_VOICES_BASE}ru/ru_RU/irina/medium/ru_RU-irina-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}ru/ru_RU/irina/medium/ru_RU-irina-medium.onnx.json`,
    speakerId: undefined,
    gender: "f",
    language: "ru-RU",
    languageName: "Russian (Russia)",
  },
  dimitri: {
    name: "dimitri",
    modelUrl: `${PIPER_VOICES_BASE}ru/ru_RU/dimitri/medium/ru_RU-dimitri-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}ru/ru_RU/dimitri/medium/ru_RU-dimitri-medium.onnx.json`,
    speakerId: undefined,
    gender: "m",
    language: "ru-RU",
    languageName: "Russian (Russia)",
  },
  artur: {
    name: "artur",
    modelUrl: `${PIPER_VOICES_BASE}sl/sl_SL/artur/medium/sl_SL-artur-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}sl/sl_SL/artur/medium/sl_SL-artur-medium.onnx.json`,
    speakerId: undefined,
    gender: "m",
    language: "sl-SL",
    languageName: "Slovenian (Slovenia)",
  },
  anders: {
    name: "anders",
    modelUrl: `${PIPER_VOICES_BASE}sv/sv_SE/nst/medium/sv_SE-nst-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}sv/sv_SE/nst/medium/sv_SE-nst-medium.onnx.json`,
    speakerId: undefined,
    gender: "m",
    language: "sv-SE",
    languageName: "Swedish (Sweden)",
  },
  ahmet: {
    name: "ahmet",
    modelUrl: `${PIPER_VOICES_BASE}tr/tr_TR/dfki/medium/tr_TR-dfki-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}tr/tr_TR/dfki/medium/tr_TR-dfki-medium.onnx.json`,
    speakerId: undefined,
    gender: "m",
    language: "tr-TR",
    languageName: "Turkish (Turkey)",
  },
  lada: {
    name: "lada",
    modelUrl: `${PIPER_VOICES_BASE}uk/uk_UA/ukranian_tts/medium/uk_UA-ukranian_tts-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}uk/uk_UA/ukranian_tts/medium/uk_UA-ukranian_tts-medium.onnx.json`,
    speakerId: 0,
    gender: "f",
    language: "uk-UA",
    languageName: "Ukrainian (Ukraine)",
  },
  tetiana: {
    name: "tetiana",
    modelUrl: `${PIPER_VOICES_BASE}uk/uk_UA/ukranian_tts/medium/uk_UA-ukranian_tts-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}uk/uk_UA/ukranian_tts/medium/uk_UA-ukranian_tts-medium.onnx.json`,
    speakerId: 2,
    gender: "f",
    language: "uk-UA",
    languageName: "Ukrainian (Ukraine)",
  },
  mykyta: {
    name: "mykyta",
    modelUrl: `${PIPER_VOICES_BASE}uk/uk_UA/ukranian_tts/medium/uk_UA-ukranian_tts-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}uk/uk_UA/ukranian_tts/medium/uk_UA-ukranian_tts-medium.onnx.json`,
    speakerId: 1,
    gender: "m",
    language: "uk-UA",
    languageName: "Ukrainian (Ukraine)",
  },
  alys: {
    name: "alys",
    modelUrl: `${PIPER_VOICES_BASE}cy/cy_GB/bu_tts/medium/cy_GB-bu_tts-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}cy/cy_GB/bu_tts/medium/cy_GB-bu_tts-medium.onnx.json`,
    speakerId: 1,
    gender: "f",
    language: "cy-GB",
    languageName: "Welsh (Great Britain)",
  },
  arthur: {
    name: "arthur",
    modelUrl: `${PIPER_VOICES_BASE}cy/cy_GB/bu_tts/medium/cy_GB-bu_tts-medium.onnx`,
    modelConfigUrl: `${PIPER_VOICES_BASE}cy/cy_GB/bu_tts/medium/cy_GB-bu_tts-medium.onnx.json`,
    speakerId: 2,
    gender: "m",
    language: "cy-GB",
    languageName: "Welsh (Great Britain)",
  },
};

export type VoiceNames = keyof typeof voices;

export const voiceNames: VoiceNames[] = Object.keys(voices) as VoiceNames[];

export type Environments =
  | "sky"
  | "tokyo"
  | "candyshop"
  | "livingroom (futuristic)";

export const environments: Environments[] = [
  "sky",
  "tokyo",
  "candyshop",
  "livingroom (futuristic)",
];
